import { render, staticRenderFns } from "./Detect.Detail.vue?vue&type=template&id=380b8794&"
import script from "./Detect.Detail.vue?vue&type=script&lang=js&"
export * from "./Detect.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports